// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
export const ROUTERS = {
  RESET_PASSWORD: '/web/reset-password',
  NOT_FOUND: '/404',
  DELETE_ACCOUNT: '/web/delete-account',
  DELETE_ACCOUNT_SUCCESS: '/web/delete-success',
  PRIVACY: '/privacy',
  TERM_OF_USE: '/term-of-use',
  HOME: '/web/',
  HEALTH_CHECK: '/health-check',
  MAGAZINES: '/magazines/:id',
  SPOT: '/spots/:id',
  NOT_FOUND_CONTENT: '/not-found-content',
  COMERCIAL: '/commercial-transactions',
  QR_CODE: '/qrcode',
  QR_CODE_WEB_SERVICE: '/qrcode_external_site',
  QRCODE_NOT_FOUND: '/qrcode-not-found',
};
